import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import {Link} from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';

import {Event} from "../types/Event";
import {useTheme} from "@mui/material/styles";

const events: Event[] = [
    {
        img: "/dizengoff_mommies/sliding_images/8.jpg",
        title: "מתחברים דרך מילים - התפתחות השפה והתקשורת בשנה הראשונה",
        lecturer: "הודיה פנסאפורקאר - קלינאית תקשורת",
        details: "3.12.25 | אבן גבירול 76",
        linkToRegister: "https://pay.grow.link/cf3d85c9089510522127bc0d8dd3f80a-MTkzMTgyMg"
    },
    {
        img: "/dizengoff_mommies/sliding_images/10.jpg",
        title: "משחקים עם מילים",
        lecturer: "הודיה פנסאפורקאר - קלינאית תקשורת",
        details: "24.12.25 | ZOOM",
        linkToRegister: "https://pay.grow.link/02b53ff622abe11216b131d254c49b9c-MjE2OTcwMA"
    }
];

function UpcomingEvents() {
    const theme = useTheme();

    return (
        <Box
            pt={2}
            pb={2}
        >
            <Box>
                <Typography
                    variant="h4"
                    fontWeight={600}
                    sx={{
                        pb: 4
                    }}
                >
                    Upcoming Events
                </Typography>
            </Box>
            <Grid
                container
                rowSpacing={1}
                justifyContent={"center"}
            >
                {events.map((event, index) => (
                    <Grid
                        key={`${index}`}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{
                            display: "flex", // Flexbox layout
                            flexDirection: "column", // Column direction for child elements
                            alignItems: "center", // Center alignment for content
                            border: "1px solid white", // Border around the grid item
                            padding: 1, // Add padding inside the grid
                            margin: 2, // Outer margin
                        }}
                    >
                        <Box
                            component="img"
                            src={event.img}
                            alt={`lecturer ${index}`}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"
                            }}
                        />
                        <Typography
                            variant={"h5"}
                            sx={{
                                fontWeight: "600",
                                pt: 1,
                                pb: 1
                            }}
                        >
                            {event.title}
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: "600"
                            }}
                        >
                            {event.lecturer}
                        </Typography>
                        <Typography
                            variant="h6"
                        >
                            {event.details}
                        </Typography>
                        <Box
                            sx={{
                                mt: 3,
                                mb: 2,
                            }}
                        >
                            {
                                event.linkToRegister ?
                                    <Box
                                        sx={{
                                            display: "flex", // Use flexbox for alignment
                                            alignItems: "center", // Align items vertically
                                            backgroundColor: "white",
                                            color: theme.palette.background.default,
                                            borderRadius: 2,
                                            p: 1,
                                            gap: 1, // Space between the text and the icon
                                        }}
                                    >
                                        <Link
                                            href={event.linkToRegister}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            underline={"none"}
                                            sx={{
                                                color: theme.palette.background.default,
                                            }}
                                        >
                                            להרשמה
                                        </Link>
                                        <LinkIcon/>
                                    </Box>
                                    :
                                    <Typography>
                                        {event.custom_text}
                                    </Typography>
                            }
                        </Box>
                        {
                            event.linkToWaitingList &&
                            <Box
                                sx={{
                                    display: "flex", // Use flexbox for alignment
                                    alignItems: "center", // Align items vertically
                                    backgroundColor: "white",
                                    color: theme.palette.background.default,
                                    borderRadius: 2,
                                    p: 1,
                                    gap: 1, // Space between the text and the icon
                                    mb: 2,
                                }}
                            >
                                <Link
                                    href={event.linkToWaitingList}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    underline={"none"}
                                    sx={{
                                        color: theme.palette.background.default,
                                    }}
                                >
                                    לרשימת המתנה
                                </Link>
                                <LinkIcon/>
                            </Box>
                        }
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default UpcomingEvents;
